module.exports = __webpack_public_path__ + "static/img/next_q_btn.99c596de.png";